import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import { useNavigate } from "react-router";

// Login reminder for manufacturer-pushed contracts waiting in the provider's
// "Received Contracts" inbox (e.g. the auto-pushed PSA). Mirrors
// ModalPsaReminder, but routes to the Received Contracts page — the real
// signing surface for the contract-based flow — instead of the standalone PSA.
function ModalReceivedContractsReminder({ close, count = 1 }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleReviewNow = () => {
    close();
    navigate("/settings/receivedContracts");
  };

  return (
    <Modal
      close={close}
      title={t("common.receivedContractsReminder.title", "You have a contract to sign")}
      show={true}
      size="small"
    >
      <div className="dme-reminder-content">
        <div className="reminder-icon mb-20">
          <i className="material-symbols-outlined">gavel</i>
        </div>

        <p className="mb-20">
          {count > 1
            ? t(
                "common.receivedContractsReminder.messagePlural",
                "Your manufacturer has sent you {{count}} contracts to review and sign before orders can ship.",
                { count }
              )
            : t(
                "common.receivedContractsReminder.message",
                "Your manufacturer has sent you a contract to review and sign before orders can ship. It takes about a minute."
              )}
        </p>

        <ul className="reminder-benefits mb-20">
          <li>{t("common.receivedContractsReminder.benefit1", "Required before your orders can be processed")}</li>
          <li>{t("common.receivedContractsReminder.benefit2", "Recorded with a timestamp and audit trail for compliance")}</li>
          <li>{t("common.receivedContractsReminder.benefit3", "You can review the full contract before signing")}</li>
        </ul>
      </div>

      <div className="modal-actions btn-bar">
        <button className="btn btn-secondary" onClick={close}>
          {t("common.receivedContractsReminder.later", "Later")}
        </button>
        <button className="btn btn-primary" onClick={handleReviewNow}>
          {t("common.receivedContractsReminder.reviewNow", "Review & sign")}
        </button>
      </div>
    </Modal>
  );
}

export default ModalReceivedContractsReminder;
